export default from './page-cover';



// WEBPACK FOOTER //
// ./app/components/page-cover/index.js